/**
 * Same-tab memory that a register just required inbox verification.
 * Login reads this so /login is not a blank Sign In form after signup.
 */

export const PENDING_EMAIL_VERIFICATION_STORAGE_KEY =
  'fcp_pending_email_verification';

export const LOGIN_PENDING_VERIFICATION_STATE = 'pendingVerification';

export const REGISTER_CHECK_EMAIL_TESTID = 'register-check-email';

export const LOGIN_CHECK_EMAIL_HINT_TESTID = 'login-check-email-hint';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MAX_EMAIL_LEN = 254;

export function normalizePendingEmail(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_EMAIL_LEN) return null;
  if (!EMAIL_RE.test(trimmed)) return null;
  return trimmed;
}

export function persistPendingEmailVerification(email) {
  const normalized = normalizePendingEmail(email);
  if (!normalized || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(PENDING_EMAIL_VERIFICATION_STORAGE_KEY, normalized);
  } catch {
    // Private mode / quota - login hint is best-effort.
  }
}

export function readPendingEmailVerification() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    return normalizePendingEmail(
      sessionStorage.getItem(PENDING_EMAIL_VERIFICATION_STORAGE_KEY),
    );
  } catch {
    return null;
  }
}

export function clearPendingEmailVerification() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(PENDING_EMAIL_VERIFICATION_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function resolvePendingVerificationEmail(locationState) {
  const fromState =
    locationState && locationState[LOGIN_PENDING_VERIFICATION_STATE] === true
      ? locationState.email
      : null;
  return normalizePendingEmail(fromState) || readPendingEmailVerification();
}
